<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col>
                    <v-icon @click="isColorPickerOpen = !isColorPickerOpen" color="primary">mdi-brush-outline</v-icon>

                </v-col>
                
            </v-row>
            <!--<v-container>
                <v-row>
                    <v-col md="6" cols="12">-->
                        <!-- Filter by Year -->
                        <!--<v-menu v-model="yearMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                              :label="$t('Year')"
                                              readonly
                                              v-bind="attrs" @input="selectYear($event)"
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker :max="maxDate"
                                           type="year" @click:year="selectYear($event)"></v-date-picker>
                        </v-menu>

                    </v-col>
                    <v-col md="6" cols="12">-->
                        <!-- Filter by Quarter (using Calendar) -->
                        <!--<v-select hide-details v-model="selectedQuarter" @input="selectQuarter($event)" clearable outlined dense
                                  :items="quarters"
                                  :label="$t('Quarter')"></v-select>
                    </v-col>
                </v-row>
            </v-container>-->
            <!-- Color Picker Dialog -->
            <v-dialog v-model="isColorPickerOpen" max-width="400">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-color-picker v-model="chartColor" mode="hexa" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" text @click="isColorPickerOpen = false">
                            {{$t('Close')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-card-text>

        <v-card-text style="margin:auto;">
            <table style="width:100%">
                <tr v-for="(item, index) in value.filter(x=>x.value>0)" :key="index" @click="filterQuestionOption(item)">
                    <!--<td style="width:20%"><v-icon left class="mr-1">mdi-arrow-left</v-icon></td>-->
                    <td style="padding-top: 10px; font-size: 21px;"><table style="background-color:white;width:235px;height:35px;padding:0px 10px; color: #000;"><tr><td>{{ item.name }}</td></tr></table></td>
                    <td style="width: 70%; padding-top: 10px; font-size: 21px; "><div class="chart-bar" :style="{ width: item.value + '%', backgroundColor:chartColor }"><div style="width:50px; color: #000;">{{ item.value }}%</div></div></td>
                </tr>
            </table>
            <!--<div class="chart-item" v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
            <v-row>
                <v-col cols="2">
                    <table style="background-color:white;width:100%;height:35px;padding:0px 10px">
                        <tr>
                            <td>{{ item.name }}</td>
                            <td style="width:20%">
                                <v-icon left class="mr-1">mdi-arrow-left</v-icon>
                            </td>
                        </tr>
                    </table>
                </v-col>
                <v-col>
                    <div class="chart-bar" :style="{ width: item.value + '%', backgroundColor: chartColor }"><div style="width:30px">{{ item.value }}%</div></div>
                </v-col>
            </v-row>
        </div>-->
        </v-card-text>
        
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            quarters: {
                type: Array,
                default: () => [],
            },
            q: undefined

        },
        data() {
            return {

                selectedChart: 'chart1', // Default to horizontal view
                isColorPickerOpen: false, // Controls the dialog visibility
                chartColor: '#00bcd4', // Default chart color,
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                maxDate: new Date().toISOString().split('T')[0],
            }
        },
        methods: {
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
                this.$emit('selectProfessionYear', year)
            },
            selectQuarter(quarter) {
                this.$emit('selectProfessionQuarter', quarter)
            },
            filterQuestionOption(item) {
                this.$emit('filterQuestionOption', item, this.q, this.value)
            }
        }
    }
</script>

<style scoped>
    .chart-card {
        width: 30%;
        padding: 16px;
        background-color: #f5f5f5;
        border-radius: 8px;
    }

    .chart-title {
        background-color: #00bcd4;
        color: white;
        padding: 8px;
        border-radius: 4px;
        text-align: center;
    }

    .chart-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
    }

    .chart-bar {
        height: 35px;
        line-height: 35px;
        color: white;
        text-align: right;
        padding-right: 8px;
        min-width: 0px;
    }

    .vertical-bar {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 120px;
        position: relative;
        margin:0 10px;
        width:50px;
    }

    .barcontainer {
        position: absolute;
        bottom: 50px;
        text-align: center;
    }

    .barname {
        position1: absolute;
        bottom1: 0px;
        width: 50px;
        word-wrap: break-word;
        height: 70px;
    }

        .barname span {
            display: block;
            transform: rotate(-70deg);
            width: 210px !important;
            margin-top: 70px;
            margin-right: -30px;
            height: 10px;
        }

    .bar {
        width: 50px;
        height: 100%;
        color: white;
        text-align: center;
    }

    .titlebackground {
        background-image: url('/public/titlebackground.png');
        background-repeat: no-repeat;
        height: 51px;
        background-size: contain;
        width: 100%;
        color: white;
        padding: 0 10px;
        line-height: 51px;
        background-position: right
    }
</style>
